export default __webpack_public_path__ + "static/media/post-image.51efc78a.png";